export default {
  // 2-1
  sfactory_list: [],
  workarea_list: [],
  reason_list: [],
  worktype_list: [],
};
